(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["greatest-gift-campaign"] && !Shopify.designMode) return;
  try {
    (function (root, factory) {
    var api = factory();

    if (typeof module === 'object' && module.exports) {
      module.exports = api;
    }

    if (!root || !root.document) return;

    root.GreatestGiftCampaign = api;

    function launch() {
      api.start(root);
    }

    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', launch, { once: true });
    }
    else {
      launch();
    }
  })(typeof window === 'undefined' ? null : window, function () {
    function normalizeId(value) {
      return String(value == null ? '' : value);
    }

    function normalizeSku(value) {
      return String(value == null ? '' : value).trim().toLowerCase();
    }

    function getQualifyingQuantity(cart, config) {
      var qualifyingSkus = new Set((config.qualifyingSkus || []).map(normalizeSku));

      return (cart.items || []).reduce(function (total, item) {
        var properties = item.properties || {};
        var isCampaignGift = properties[config.campaignProperty] === config.campaign;
        var qualifies = qualifyingSkus.has(normalizeSku(item.sku));
        return total + (qualifies && !isCampaignGift ? Number(item.quantity || 0) : 0);
      }, 0);
    }

    function getEligibleTier(quantity, config) {
      return (config.tiers || []).reduce(function (eligible, tier) {
        return quantity >= tier.threshold && (!eligible || tier.threshold > eligible.threshold) ? tier : eligible;
      }, null);
    }

    function getTshirtVariants(config) {
      return Object.keys(config.giftVariants.tshirt || {}).map(function (size) {
        return normalizeId(config.giftVariants.tshirt[size]);
      });
    }

    function getAllGiftVariantIds(config) {
      return new Set([
        normalizeId(config.giftVariants.keychain),
        normalizeId(config.giftVariants.socks),
        normalizeId(config.giftVariants.metalCan)
      ].concat(getTshirtVariants(config)));
    }

    function getSelectedTshirtVariant(config, storedVariantId) {
      var validVariants = getTshirtVariants(config);
      var normalizedStoredId = normalizeId(storedVariantId);

      if (validVariants.indexOf(normalizedStoredId) !== -1) {
        return normalizedStoredId;
      }

      return normalizeId(config.giftVariants.tshirt[config.defaultTshirtSize]);
    }

    function getDesiredVariantIds(tier, config, selectedTshirtVariantId) {
      if (!tier) return [];

      return tier.gifts.map(function (gift) {
        if (gift === 'tshirt') return getSelectedTshirtVariant(config, selectedTshirtVariantId);
        return normalizeId(config.giftVariants[gift]);
      });
    }

    function planCartChanges(cart, config, selectedTshirtVariantId) {
      var qualifyingQuantity = getQualifyingQuantity(cart, config);
      var tier = getEligibleTier(qualifyingQuantity, config);
      var desiredVariantIds = getDesiredVariantIds(tier, config, selectedTshirtVariantId);
      var remainingDesired = new Map();
      var allGiftVariantIds = getAllGiftVariantIds(config);
      var changes = [];

      desiredVariantIds.forEach(function (variantId) {
        remainingDesired.set(variantId, (remainingDesired.get(variantId) || 0) + 1);
      });

      (cart.items || []).forEach(function (item) {
        var variantId = normalizeId(item.id || item.variant_id);
        var properties = item.properties || {};
        var isKnownGift = allGiftVariantIds.has(variantId);
        var isMarkedGift = properties[config.campaignProperty] === config.campaign;

        if (!isKnownGift && !isMarkedGift) return;

        var desiredCount = remainingDesired.get(variantId) || 0;
        if (desiredCount > 0) {
          remainingDesired.set(variantId, desiredCount - 1);
          if (Number(item.quantity) !== 1) {
            changes.push({ key: item.key, quantity: 1 });
          }
        }
        else {
          changes.push({ key: item.key, quantity: 0 });
        }
      });

      var additions = [];
      remainingDesired.forEach(function (quantity, variantId) {
        if (quantity > 0) additions.push({ id: variantId, quantity: quantity });
      });

      return {
        qualifyingQuantity: qualifyingQuantity,
        tier: tier,
        desiredVariantIds: desiredVariantIds,
        changes: changes,
        additions: additions,
        changed: changes.length > 0 || additions.length > 0
      };
    }

    function getCartRoot(root) {
      var path = root.Shopify && root.Shopify.routes && root.Shopify.routes.root;
      path = path || '/';
      return path.endsWith('/') ? path : path + '/';
    }

    function createClient(root) {
      var cartRoot = getCartRoot(root);

      async function request(path, options) {
        var response = await root.fetch(cartRoot + path, options);
        var body = await response.json();

        if (!response.ok || body.status) {
          throw new Error(body.description || body.message || 'Cart request failed');
        }

        return body;
      }

      function post(path, body) {
        return request(path, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body)
        });
      }

      return {
        getCart: function () {
          return request('cart.js', { method: 'GET', credentials: 'same-origin' });
        },
        changeLine: function (key, quantity, sections, sectionsUrl) {
          var body = { id: key, quantity: quantity };
          if (sections && sections.length > 0) {
            body.sections = sections;
            body.sections_url = sectionsUrl;
          }
          return post('cart/change.js', body);
        },
        addItems: function (items, config, tier, sections, sectionsUrl) {
          var body = {
            items: items.map(function (item) {
              var properties = {};
              properties[config.campaignProperty] = config.campaign;
              properties[config.tierProperty] = String(tier.threshold);

              return {
                id: Number(item.id),
                quantity: item.quantity,
                properties: properties
              };
            })
          };
          if (sections && sections.length > 0) {
            body.sections = sections;
            body.sections_url = sectionsUrl;
          }
          return post('cart/add.js', body);
        },
        getCartRoot: function () {
          return cartRoot;
        }
      };
    }

    function readConfig(document) {
      var element = document.getElementById('GreatestGiftCampaignConfig');
      if (!element) return null;

      try {
        return JSON.parse(element.textContent);
      }
      catch (error) {
        return null;
      }
    }

    function getBundledSections(root) {
      var sections = [];
      root.document.documentElement.dispatchEvent(new root.CustomEvent('cart:bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));
      return Array.from(new Set(sections));
    }

    function publishThemeCart(root, cart, sections) {
      if (root.theme && root.theme.pubsub && sections) {
        cart.sections = sections;
        root.theme.pubsub.publish(root.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'greatest-gift-campaign',
          cart: cart
        });
      }
      else {
        root.document.dispatchEvent(new root.CustomEvent('cart:refresh', { detail: { open: false } }));
      }
    }

    function setStatus(document, message) {
      var status = document.querySelector('[data-greatest-gift-status]');
      if (status) status.textContent = message || '';
    }

    function createSizeController(root, config, schedule) {
      var dialog = root.document.querySelector('[data-greatest-gift-dialog]');
      var trigger = root.document.querySelector('[data-greatest-gift-size-trigger]');
      var buttons = Array.from(root.document.querySelectorAll('[data-greatest-gift-size]'));
      var storageKey = config.campaign + ':tshirt-variant';

      function getSelectedVariantId() {
        try {
          return root.localStorage.getItem(storageKey);
        }
        catch (error) {
          return null;
        }
      }

      function updateButtons() {
        var selected = getSelectedTshirtVariant(config, getSelectedVariantId());
        buttons.forEach(function (button) {
          button.setAttribute('aria-pressed', normalizeId(button.dataset.variantId) === selected ? 'true' : 'false');
        });
      }

      function open() {
        if (!dialog) return;
        updateButtons();
        if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          try {
            root.localStorage.setItem(storageKey, normalizeId(button.dataset.variantId));
          }
          catch (error) {
            return;
          }

          updateButtons();
          if (dialog && dialog.open) dialog.close();
          schedule();
        });
      });

      if (trigger) trigger.addEventListener('click', open);
      if (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) dialog.close();
        });
      }

      return {
        selectedVariantId: getSelectedVariantId,
        update: function (cart, tier) {
          var hasTshirtTier = Boolean(tier && tier.gifts.indexOf('tshirt') !== -1);
          if (trigger) trigger.hidden = !hasTshirtTier;
          if (!hasTshirtTier || getSelectedVariantId()) return;

          var promptKey = config.campaign + ':size-prompt:' + String(cart.token || 'cart');
          try {
            if (root.sessionStorage.getItem(promptKey)) return;
            root.sessionStorage.setItem(promptKey, '1');
          }
          catch (error) {
            return;
          }
          open();
        }
      };
    }

    function start(root) {
      var config = readConfig(root.document);
      if (!config || !config.enabled) return null;

      var client = createClient(root);
      var running = false;
      var rerun = false;
      var sizeController;

      async function reconcile() {
        var cart = await client.getCart();
        var plan = planCartChanges(cart, config, sizeController.selectedVariantId());

        if (plan.changed) {
          var bundledSections = getBundledSections(root);
          var sectionResponse = null;

          for (var index = 0; index < plan.changes.length; index += 1) {
            var isFinalChange = index === plan.changes.length - 1 && plan.additions.length === 0;
            sectionResponse = await client.changeLine(
              plan.changes[index].key,
              plan.changes[index].quantity,
              isFinalChange ? bundledSections : null,
              root.location.pathname
            );
          }

          if (plan.additions.length > 0) {
            sectionResponse = await client.addItems(
              plan.additions,
              config,
              plan.tier,
              bundledSections,
              root.location.pathname
            );
          }

          cart = await client.getCart();
          publishThemeCart(root, cart, sectionResponse && sectionResponse.sections);
          setStatus(
            root.document,
            plan.additions.length > 0 ? config.messages.added : plan.tier ? config.messages.updated : config.messages.removed
          );
        }

        sizeController.update(cart, plan.tier);
        return plan;
      }

      async function schedule() {
        if (running) {
          rerun = true;
          return;
        }

        running = true;
        try {
          await reconcile();
        }
        catch (error) {
          setStatus(root.document, config.messages.unavailable);
          if (root.console && root.console.warn) root.console.warn('Greatest gift campaign:', error.message);
        }
        finally {
          running = false;
          if (rerun) {
            rerun = false;
            schedule();
          }
        }
      }

      sizeController = createSizeController(root, config, schedule);

      if (root.theme && root.theme.pubsub) {
        root.theme.pubsub.subscribe(root.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, schedule);
      }
      root.document.addEventListener('ajaxProduct:added', schedule);
      root.document.addEventListener('cart:updated', schedule);
      root.addEventListener('pageshow', schedule);
      root.document.addEventListener('visibilitychange', function () {
        if (root.document.visibilityState === 'visible') schedule();
      });

      schedule();
      return { schedule: schedule, reconcile: reconcile };
    }

    return {
      getQualifyingQuantity: getQualifyingQuantity,
      getEligibleTier: getEligibleTier,
      getDesiredVariantIds: getDesiredVariantIds,
      getSelectedTshirtVariant: getSelectedTshirtVariant,
      planCartChanges: planCartChanges,
      start: start
    };
  });
  } catch(e) { console.error(e); }
})();

})();
